import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <section className="w-full bg-cream px-4 py-16 sm:py-20" aria-labelledby="testimonials-heading" data-id="element-281" data-mp="3mgaf6jdmfgpb">
      <div className="mx-auto max-w-5xl" data-id="element-282" data-mp="3r80vd5z8oyon">
        <p className="text-center font-display text-sm font-extrabold uppercase tracking-widest text-gold-600" data-id="element-283" data-mp="3r93mnf0h5353">Professional feedback</p>
        <h2 id="testimonials-heading" className="mt-3 text-center font-display text-[1.7rem] font-black leading-tight text-navy-950 sm:text-4xl" data-id="element-284" data-mp="42t0f4mh6flc">
          What Dental Professionals Say About Smile Design Roadmap™
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-285" data-mp="e18w7kwg6d16">
          {testimonials.map(t => <figure key={t.topic} className="flex flex-col rounded-3xl bg-white p-6 shadow-[0_10px_30px_-18px_rgba(10,27,56,0.4)]" data-id="element-286" data-mp="2aual1hhj1e6k">
              <div className="flex items-center gap-4" data-id="element-287" data-mp="2fug8smkoegjd">
                <img src={t.image} alt={`Photo of ${t.role.toLowerCase()}`} className="h-16 w-16 shrink-0 rounded-full border-[3px] border-gold-400 object-cover" loading="lazy" data-id="element-288" data-mp="1slkr9f00hcj1" />
                <div data-id="element-289" data-mp="1iu7z0maawkch">
                  <div className="flex gap-0.5 text-gold-500" aria-label="5 out of 5 stars" data-id="element-290" data-mp="1ivreiao4urd7">
                    {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-291" data-mp="1erbakey2xu0m" />)}
                  </div>
                  <p className="mt-1 font-display text-sm font-extrabold text-navy-950" data-id="element-292" data-mp="26k2aazez20um">{t.topic}</p>
                </div>
              </div>
              <blockquote className="relative mt-5 flex-1 text-[15px] leading-relaxed text-ink/85" data-id="element-293" data-mp="22gvw95lmb5dl">
                <QuoteIcon className="mb-2 h-5 w-5 text-gold-400" aria-hidden="true" data-id="element-294" data-mp="1xjcj690noyn8" />
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-5 border-t border-navy-900/10 pt-4 text-sm font-bold text-navy-900" data-id="element-295" data-mp="m4qj7ehlthx2">— {t.role}</figcaption>
            </figure>)}
        </div>

        <div className="mt-12" data-id="element-296" data-mp="njtbcibi61f8">
          <CTAButton label="Explore the complete Roadmap™" sublabel="Join dental professionals planning with clarity" data-id="element-297" data-mp="sl8shzak7nsc" />
        </div>
      </div>
    </section>;
}